/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AddInputs */

const en_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const fr_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

const de_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

const it_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungere`)
};

const ru_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавлять`)
};

const es_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

const zh_cn2_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加`)
};

const ja_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

const hi_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ना`)
};

const pt_pt2_add = /** @type {(inputs: AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const add = /** @type {((inputs?: AddInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AddInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_add(inputs)
	if (locale === "de") return de_add(inputs)
	if (locale === "it") return it_add(inputs)
	if (locale === "ru") return ru_add(inputs)
	if (locale === "es") return es_add(inputs)
	if (locale === "zh-CN") return zh_cn2_add(inputs)
	if (locale === "ja") return ja_add(inputs)
	if (locale === "hi") return hi_add(inputs)
	if (locale === "pt-PT") return pt_pt2_add(inputs)
	return en_add(inputs)
});